import React, { useEffect, useRef, useState } from "react";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import CommonDatePickerFilter from "../../../../../../components/filters/CommonDatePicker.filter";
import CommonDropdownFilter from "../../../../../../components/filters/CommonDropdown.filter";
import Checkbox from "../../../../../../components/ui/inputs/checkBox/CheckBox";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import { useGetAllContractInvoicesMutation } from "../../../../../../app/services/contractAPI";
const PriorInvoices = () => {
  const gridRef = useRef();

  const [isChexboxChecked, setIsCheckboxChecked] = useState(false);
  const [startDate, setStartDate] = useState(new Date().setMonth(new Date().getMonth() - 1));
  const [endDate, setEndDate] = useState(new Date());
  const [gridData, setGridData] = useState([]);

  const [contractInvoiceGet, {
    isSuccess: iscontractInvoiceGet,
    data: contractInvoiceData
  }] = useGetAllContractInvoicesMutation();


  useEffect(() => {
      contractInvoiceGet({
        plContractKey: 489,
        plDepartmentKey: 0,
        plInvoiceKey: 0,
        pdtStartDate: null,
        pdtEndDate: null
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDatePickerChange = (dataField, selectedDate) => {
    if(dataField === "startDate") {
      setStartDate(selectedDate);
    } else if(dataField === "endDate") {
      setEndDate(selectedDate);
    }
  };

  useEffect(() => {
    if (iscontractInvoiceGet && contractInvoiceData) {
      setGridData(contractInvoiceData);
    }
  }, [iscontractInvoiceGet, contractInvoiceData]);

  return (
    <>
      <CardSection>
        <div className="prior-invoice-detail">
          <div className="top-form-section">
            <div className="row">
              <div className="col-md-4 from-to-sec">
                <div className="w-100 d-flex gap-3">
                  <CommonDatePickerFilter
                    value={startDate}
                    label={"From : "}
                    placeholder="MM/DD/YYYY"
                    onChange={(selectedDate) => handleDatePickerChange("startDate", selectedDate)}
                  />
                  <CommonDatePickerFilter
                    value={endDate}
                    label={"To : "}
                    placeholder="MM/DD/YYYY"
                    onChange={(selectedDate) => handleDatePickerChange("endDate", selectedDate)}
                  />
                </div>
              </div>
              <div className="col-md-4 type-spacing">
                <CommonDropdownFilter
                  label={"Contract : "}
                  placeholder="Select Type"
                  // listOptions={filter.type?.options}
                  // selectedValue={filter.type?.value}
                  // onChange={(selectedValue) => handleDropdownChange("type", selectedValue?.value)}
                />
              </div>
              <div className="col-md-2 check-box-sec d-flex align-items-center">
                <Checkbox
                  key="expiredInvoices"
                  name="expiredInvoices"
                  label="Include Expired"
                  checked={isChexboxChecked}
                  onChange={() => setIsCheckboxChecked(!isChexboxChecked)}
                  // checked={instrumentInclude[item.id]}
                  // onChange={(dataField, isChecked) =>
                  //   handleCheckboxChange(dataField, isChecked)
                  // }
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end align-items-center">
                <div className="btn-sec">
                  <Buttons
                    buttonText={"Refresh"}
                    buttonTypeClassName="btn blue-btn"
                    // onClick={() => setIsModelOpen(true)}
                  />
                </div>
              </div>
            </div>
          </div>
          <MolGrid
            ref={gridRef}
            // beforeLoad={beforeMolGridLoad}
            // afterLoad={afterMolGridLoad}
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            // ctxMenuItems={getCtxMenuItems}
            // onRowDoubleClick={handleRowDoubleClick}
          >
            <Column
              field="lContractKey"
              header="Contract Key"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "7%" }}
              grouping
              sortable
            />
            <Column
              field="sContractName1"
              header="Contract"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "25%" }}
              grouping
              sortable
            />
            <Column
              field="sClientName1"
              header="Client"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "20%" }}
              grouping
              sortable
            />
            <Column
              field="sDepartmentName"
              header="Department"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "12%" }}
              grouping
              sortable
            />
            <Column
              field="sPurchaseOrder"
              header="Purchase Order"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="dtTranDate"
              header="Invoice Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "7%" }}
              colType="datetime"
              format="mm/dd/yyyy"
              grouping
              sortable
            />
            <Column
              field="sTranNumber"
              header="Invoice Number"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "7%" }}
              grouping
              sortable
            />

            <Column
              field="dblTranAmount"
              header="Invoice Amount"
              bodyStyle={{ textAlign: "Right" }}
              style={{ width: "7%" }}
              colType="money"
              grouping
              sortable
            />
            <Column
              field="sCoveragePeriod"
              header="Coverage Period"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
          </MolGrid>
        </div>
      </CardSection>
    </>
  );
};

export default PriorInvoices;
